import i18n from "../services/i18n"
const I18n = (props: {value: string}) => {
  return <>{i18n.get(props.value)}</>
}
export default I18n